// GENERATED by shared/i18n/tools/gen.py from shared/i18n/en.json + locales.json. Do not edit: change the catalog,
// then run `npm run i18n` (docs/I18N.md).

export const SOURCE_LOCALE = 'en';

export const LOCALES = [
  { code: 'en', name: 'English', nativeName: 'English', pseudo: false, dir: 'ltr' },
  { code: 'zh-Hans', name: 'Chinese (Simplified)', nativeName: '简体中文', pseudo: false, dir: 'ltr' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', pseudo: false, dir: 'ltr' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)', pseudo: false, dir: 'ltr' },
  { code: 'es-419', name: 'Spanish (Latin America)', nativeName: 'Español (Latinoamérica)', pseudo: false, dir: 'ltr' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', pseudo: false, dir: 'ltr' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', pseudo: false, dir: 'ltr' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', pseudo: false, dir: 'ltr' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', pseudo: false, dir: 'ltr' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', pseudo: false, dir: 'ltr' },
  { code: 'fr', name: 'French', nativeName: 'Français', pseudo: false, dir: 'ltr' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', pseudo: false, dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', pseudo: false, dir: 'rtl' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', pseudo: false, dir: 'ltr' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', pseudo: false, dir: 'ltr' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська', pseudo: false, dir: 'ltr' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', pseudo: false, dir: 'ltr' },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', pseudo: false, dir: 'rtl' },
  { code: 'en-XA', name: 'Pseudo-locale (testing)', nativeName: '[Þšéûðö]', pseudo: true, dir: 'ltr' },
] as const;

export type LocaleCode = (typeof LOCALES)[number]['code'];

/** Every catalog key and the arguments its message takes (integers for {n, number} and plural counts). */
export interface MessageArgs {
  'tour.step.welcome.title': Record<string, never>;
  'tour.step.welcome.body_1': Record<string, never>;
  'tour.step.welcome.body_2': Record<string, never>;
  'tour.step.env.title': Record<string, never>;
  'tour.step.env.body_1': Record<string, never>;
  'tour.step.env.body_2': Record<string, never>;
  'tour.step.catalog.title': Record<string, never>;
  'tour.step.catalog.body_1': Record<string, never>;
  'tour.step.catalog.body_2': Record<string, never>;
  'tour.step.catalog_controls.title': Record<string, never>;
  'tour.step.catalog_controls.body_1': Record<string, never>;
  'tour.step.catalog_controls.body_2': Record<string, never>;
  'tour.step.market_sides.title': Record<string, never>;
  'tour.step.market_sides.body_1': Record<string, never>;
  'tour.step.market_sides.body_2': Record<string, never>;
  'tour.step.market_book.title': Record<string, never>;
  'tour.step.market_book.body_1': Record<string, never>;
  'tour.step.market_book.body_2': Record<string, never>;
  'tour.step.market_trades.title': Record<string, never>;
  'tour.step.market_trades.body_1': Record<string, never>;
  'tour.step.ticket.title': Record<string, never>;
  'tour.step.ticket.body_1': Record<string, never>;
  'tour.step.ticket_price.title': Record<string, never>;
  'tour.step.ticket_price.body_1': Record<string, never>;
  'tour.step.ticket_price.body_2': Record<string, never>;
  'tour.step.ticket_economics.title': Record<string, never>;
  'tour.step.ticket_economics.body_1': Record<string, never>;
  'tour.step.ticket_economics.body_2': Record<string, never>;
  'tour.step.wallet.title': Record<string, never>;
  'tour.step.wallet.body_1': Record<string, never>;
  'tour.step.wallet.body_2': Record<string, never>;
  'tour.step.portfolio.title': Record<string, never>;
  'tour.step.portfolio.body_1': Record<string, never>;
  'tour.step.portfolio.body_2': Record<string, never>;
  'tour.step.finish.title': Record<string, never>;
  'tour.step.finish.body_1': Record<string, never>;
  'tour.step.finish.body_2': Record<string, never>;
  'tour.ui.next': Record<string, never>;
  'tour.ui.back': Record<string, never>;
  'tour.ui.skip': Record<string, never>;
  'tour.ui.finish': Record<string, never>;
  'tour.ui.step_of': { n: number; total: number };
  'tour.ui.learn': Record<string, never>;
  'tour.ui.help_menu': Record<string, never>;
  'tour.ui.replay': Record<string, never>;
  'tour.ui.tour_label': Record<string, never>;
  'tour.ui.keys_hint': Record<string, never>;
  'orders.cancel.summary_action': { count: number };
  'common.close': Record<string, never>;
  'common.dismiss': Record<string, never>;
  'common.retry': Record<string, never>;
  'common.back_to_markets': Record<string, never>;
  'common.network.testnet': Record<string, never>;
  'common.network.mainnet': Record<string, never>;
  'common.cancel': Record<string, never>;
  'common.yes': Record<string, never>;
  'common.no': Record<string, never>;
  'common.bool_yes': Record<string, never>;
  'common.bool_no': Record<string, never>;
  'shell.footer.tagline': Record<string, never>;
  'shell.footer.how_it_works': Record<string, never>;
  'common.privacy': Record<string, never>;
  'shell.nav.label': Record<string, never>;
  'nav.markets': Record<string, never>;
  'nav.portfolio': Record<string, never>;
  'nav.learn': Record<string, never>;
  'shell.header.home': Record<string, never>;
  'shell.env.label': Record<string, never>;
  'shell.env.testnet': Record<string, never>;
  'shell.env.mainnet': Record<string, never>;
  'shell.env.switched': { network: string };
  'shell.env.switched_body': Record<string, never>;
  'shell.mainnet_banner': Record<string, never>;
  'shell.settings': Record<string, never>;
  'shell.health.offline': Record<string, never>;
  'shell.health.degraded': { network: string };
  'shell.health.down': { network: string };
  'shell.health.dismiss': Record<string, never>;
  'shell.live.connected': Record<string, never>;
  'shell.live.connecting': Record<string, never>;
  'shell.live.reconnecting': Record<string, never>;
  'shell.live.offline': Record<string, never>;
  'shell.live.tooltip': { state: string; health: string };
  'shell.live.sr': { state: string };
  'shell.live.health_ok': Record<string, never>;
  'shell.live.health_degraded': Record<string, never>;
  'shell.live.health_down': Record<string, never>;
  'shell.toasts.label': Record<string, never>;
  'shell.toasts.dismiss': Record<string, never>;
  'shell.not_found.title': Record<string, never>;
  'wallet.connect': Record<string, never>;
  'wallet.connecting': Record<string, never>;
  'wallet.ghost_aria': { address: string };
  'wallet.wallet_short': { address: string };
  'wallet.ghost_badge': Record<string, never>;
  'wallet.watching': Record<string, never>;
  'wallet.connected': Record<string, never>;
  'wallet.connected_with': { wallet: string };
  'common.copied': Record<string, never>;
  'wallet.copy': Record<string, never>;
  'wallet.change_ghost': Record<string, never>;
  'wallet.ghost_mode_item': Record<string, never>;
  'wallet.exit_ghost': Record<string, never>;
  'wallet.disconnect': Record<string, never>;
  'wallet.connect_wallet': Record<string, never>;
  'wallet.picker.title': Record<string, never>;
  'wallet.picker.list': Record<string, never>;
  'wallet.picker.view_only': Record<string, never>;
  'wallet.picker.caveat': Record<string, never>;
  'wallet.picker.check_wallet': Record<string, never>;
  'wallet.picker.last_used': Record<string, never>;
  'wallet.picker.detected': Record<string, never>;
  'wallet.picker.none_title': Record<string, never>;
  'wallet.picker.none_body': Record<string, never>;
  'wallet.picker.install_list': Record<string, never>;
  'wallet.picker.install': { wallet: string };
  'wallet.picker.phone': { link: string };
  'wallet.picker.metamask_browser': Record<string, never>;
  'wallet.picker.just_looking': Record<string, never>;
  'wallet.picker.watch': Record<string, never>;
  'wallet.ghost.title': Record<string, never>;
  'wallet.ghost.body': Record<string, never>;
  'wallet.ghost.address_label': Record<string, never>;
  'wallet.ghost.invalid': Record<string, never>;
  'wallet.ghost.watch': Record<string, never>;
  'wallet.ghost.quick_picks': Record<string, never>;
  'wallet.ghost.pick_spec': Record<string, never>;
  'wallet.ghost.pick_trader': Record<string, never>;
  'wallet.ghost.not_valid': { input: string };
  'wallet.err.rejected': Record<string, never>;
  'wallet.err.pending': Record<string, never>;
  'wallet.err.code': { code: string };
  'wallet.err.failed': Record<string, never>;
  'wallet.err.disconnected': Record<string, never>;
  'wallet.err.none': Record<string, never>;
  'wallet.err.no_account': Record<string, never>;
  'wallet.chain_prompt.sign_first': { wallet: string };
  'wallet.chain_prompt.switch': Record<string, never>;
  'wallet.note.untested': Record<string, never>;
  'wallet.note.rabby': Record<string, never>;
  'wallet.note.rabby_add_chain': Record<string, never>;
  'wallet.note.add_network': { untested: string };
  'wallet.note.add_custom': { untested: string };
  'wallet.note.phantom': Record<string, never>;
  'wallet.note.generic': Record<string, never>;
  'wallet.generic_name': Record<string, never>;
  'catalog.count': { n: number; count: string; network: string };
  'catalog.count_filtered': { shown: string; n: number; count: string; network: string };
  'catalog.count_questions': { n: number; count: string };
  'venue.current': { venue: string };
  'catalog.prices_loading': Record<string, never>;
  'catalog.loading': { network: string };
  'catalog.load_error': { network: string };
  'catalog.unknown_error': Record<string, never>;
  'catalog.view_group': Record<string, never>;
  'catalog.view': Record<string, never>;
  'catalog.view_grouped': Record<string, never>;
  'catalog.view_flat': Record<string, never>;
  'catalog.layout_group': Record<string, never>;
  'catalog.layout': Record<string, never>;
  'catalog.layout_tiles': Record<string, never>;
  'catalog.layout_compact': Record<string, never>;
  'catalog.panel_aria': { id: string };
  'catalog.panel_full_page': Record<string, never>;
  'catalog.empty': { network: string };
  'catalog.empty_venue': { network: string; venue: string };
  'catalog.no_match': Record<string, never>;
  'catalog.clear_filters': Record<string, never>;
  'catalog.list': Record<string, never>;
  'catalog.show_more': { n: number };
  'catalog.search_placeholder': Record<string, never>;
  'catalog.search_aria': Record<string, never>;
  'catalog.sort': Record<string, never>;
  'catalog.sort_aria': Record<string, never>;
  'catalog.sort.id': Record<string, never>;
  'common.yes_price': Record<string, never>;
  'catalog.sort.name': Record<string, never>;
  'catalog.venue_filter': Record<string, never>;
  'venue.all': Record<string, never>;
  'catalog.no_venue': Record<string, never>;
  'catalog.fewer_venues': Record<string, never>;
  'catalog.more_venues': { n: number };
  'catalog.tile_aria': { id: string; title: string };
  'catalog.no_price': Record<string, never>;
  'catalog.details': Record<string, never>;
  'describe.raw_name': Record<string, never>;
  'catalog.unnamed': Record<string, never>;
  'catalog.question_aria': { title: string };
  'catalog.question_outcomes': { n: number };
  'catalog.question_settled': { n: number };
  'catalog.col_outcome': Record<string, never>;
  'catalog.show_all': { n: number };
  'catalog.tag_all': Record<string, never>;
  'catalog.tag_filter': Record<string, never>;
  'tag.crypto': Record<string, never>;
  'tag.btc': Record<string, never>;
  'tag.eth': Record<string, never>;
  'tag.sol': Record<string, never>;
  'tag.hype': Record<string, never>;
  'tag.crypto_other': Record<string, never>;
  'tag.stocks': Record<string, never>;
  'tag.indices': Record<string, never>;
  'tag.finance': Record<string, never>;
  'tag.energy': Record<string, never>;
  'tag.metals': Record<string, never>;
  'tag.sport': Record<string, never>;
  'tag.football': Record<string, never>;
  'tag.nfl': Record<string, never>;
  'tag.ncaaf': Record<string, never>;
  'tag.soccer': Record<string, never>;
  'tag.epl': Record<string, never>;
  'tag.ucl': Record<string, never>;
  'tag.uel': Record<string, never>;
  'tag.laliga': Record<string, never>;
  'tag.mls': Record<string, never>;
  'tag.world_cup': Record<string, never>;
  'tag.basketball': Record<string, never>;
  'tag.nba': Record<string, never>;
  'tag.baseball': Record<string, never>;
  'tag.mlb': Record<string, never>;
  'tag.tennis': Record<string, never>;
  'tag.hockey': Record<string, never>;
  'tag.motorsport': Record<string, never>;
  'tag.esports': Record<string, never>;
  'tag.lol': Record<string, never>;
  'tag.economics': Record<string, never>;
  'tag.rates': Record<string, never>;
  'tag.inflation': Record<string, never>;
  'tag.ipo': Record<string, never>;
  'tag.other': Record<string, never>;
  'volume.unit.thousand': Record<string, never>;
  'volume.unit.million': Record<string, never>;
  'volume.unit.billion': Record<string, never>;
  'volume.unit.trillion': Record<string, never>;
  'volume.sort': Record<string, never>;
  'volume.col_24h': Record<string, never>;
  'volume.compact': { amount: string };
  'volume.compact_aria': { amount: string };
  'volume.title': Record<string, never>;
  'volume.col.period': Record<string, never>;
  'volume.col.usd': Record<string, never>;
  'volume.col.contracts': Record<string, never>;
  'volume.col.trades': Record<string, never>;
  'volume.row.day': Record<string, never>;
  'volume.row.hour': Record<string, never>;
  'volume.row.lifetime': Record<string, never>;
  'volume.at_least': { amount: string };
  'volume.approx': { amount: string };
  'volume.hour_note': { from: string };
  'volume.lifetime_since': { date: string };
  'volume.lifetime_capped': { n: number };
  'volume.sides_note': Record<string, never>;
  'volume.loading': Record<string, never>;
  'volume.unavailable': Record<string, never>;
  'category.price': Record<string, never>;
  'describe.category.sports': Record<string, never>;
  'describe.category.event': Record<string, never>;
  'category.other': Record<string, never>;
  'describe.when.resolves': Record<string, never>;
  'describe.when.starts': Record<string, never>;
  'describe.when.decision': Record<string, never>;
  'describe.when.deadline': Record<string, never>;
  'describe.when.started': Record<string, never>;
  'describe.when.resolution_due': Record<string, never>;
  'describe.when.passed': { label: string };
  'describe.countdown.line': { label: string; when: string };
  'describe.countdown.in': { time: string };
  'describe.countdown.ended': Record<string, never>;
  'describe.countdown.lt_1m': Record<string, never>;
  'describe.countdown.d': { d: string };
  'describe.countdown.d_h': { d: string; h: string };
  'describe.countdown.h': { h: string };
  'describe.countdown.h_m': { h: string; m: string };
  'describe.countdown.m': { m: string };
  'describe.raw': Record<string, never>;
  'describe.raw_description': Record<string, never>;
  'describe.detail.template': Record<string, never>;
  'describe.detail.outcome_template': Record<string, never>;
  'describe.detail.touch_rule': Record<string, never>;
  'describe.detail.seconds': { n: number };
  'describe.detail.exact': { value: string };
  'touch.perp': Record<string, never>;
  'describe.label.underlying': Record<string, never>;
  'describe.label.threshold': Record<string, never>;
  'touch.target': Record<string, never>;
  'touch.target_price': Record<string, never>;
  'describe.label.low': Record<string, never>;
  'describe.label.high': Record<string, never>;
  'describe.label.settles_at': Record<string, never>;
  'describe.label.date': Record<string, never>;
  'describe.label.twap_window': Record<string, never>;
  'describe.label.price_source': Record<string, never>;
  'describe.label.price_feed': Record<string, never>;
  'describe.label.instrument': Record<string, never>;
  'describe.label.short_name': Record<string, never>;
  'describe.label.period': Record<string, never>;
  'describe.label.series': Record<string, never>;
  'describe.label.bucket_thresholds': Record<string, never>;
  'describe.label.side_a': Record<string, never>;
  'describe.label.side_b': Record<string, never>;
  'describe.label.short_name_a': Record<string, never>;
  'describe.label.short_name_b': Record<string, never>;
  'describe.label.scheduled_start': Record<string, never>;
  'describe.label.scheduled_decision': Record<string, never>;
  'describe.label.resolution_deadline': Record<string, never>;
  'describe.label.decision_deadline': Record<string, never>;
  'describe.label.listing_deadline': Record<string, never>;
  'describe.label.official_source': Record<string, never>;
  'describe.label.counted_play': Record<string, never>;
  'describe.label.contest_type': Record<string, never>;
  'describe.label.market_cap_threshold': Record<string, never>;
  'describe.label.lower_bound': Record<string, never>;
  'describe.label.upper_bound': Record<string, never>;
  'describe.label.competition': Record<string, never>;
  'describe.label.stage': Record<string, never>;
  'describe.label.season': Record<string, never>;
  'describe.label.sport': Record<string, never>;
  'describe.label.participant': Record<string, never>;
  'describe.label.candidate': Record<string, never>;
  'describe.label.spread': Record<string, never>;
  'describe.label.line': Record<string, never>;
  'describe.label.measure': Record<string, never>;
  'describe.label.company': Record<string, never>;
  'describe.label.award': Record<string, never>;
  'describe.label.awarding_body': Record<string, never>;
  'describe.label.field': Record<string, never>;
  'describe.label.subject': Record<string, never>;
  'describe.label.entry': Record<string, never>;
  'describe.label.display_name': Record<string, never>;
  'describe.label.institution': Record<string, never>;
  'describe.label.decision_label': Record<string, never>;
  'describe.label.policy_measure': Record<string, never>;
  'describe.label.bucket_label': Record<string, never>;
  'describe.label.event': Record<string, never>;
  'describe.label.model_a': Record<string, never>;
  'describe.label.model_b': Record<string, never>;
  'describe.label.metric': Record<string, never>;
  'describe.label.comparison_direction': Record<string, never>;
  'describe.label.leaderboard': Record<string, never>;
  'describe.label.leaderboard_url': Record<string, never>;
  'describe.label.benchmark_settings': Record<string, never>;
  'describe.label.tiebreakers': Record<string, never>;
  'describe.label.index': Record<string, never>;
  'venue.none': Record<string, never>;
  'venue.button': { venue: string };
  'venue.button_title': Record<string, never>;
  'venue.title': Record<string, never>;
  'venue.body': { network: string; param: string; paramAll: string };
  'venue.search': Record<string, never>;
  'venue.list': Record<string, never>;
  'venue.loading': Record<string, never>;
  'venue.reset': { venue: string };
  'venue.out.title': { outcome: string };
  'venue.out.body': { venue: string; network: string };
  'venue.out.body_other': { venue: string; network: string; other: string };
  'venue.out.show_all': Record<string, never>;
  'venue.show_other': Record<string, never>;
  'venue.read_only': Record<string, never>;
  'venue.hidden': { n: number };
  'market.not_found.title': { id: string };
  'market.not_found.body': { network: string };
  'market.outcome_heading': { id: string };
  'market.loading': Record<string, never>;
  'market.load_error': { error: string };
  'market.header.venue': Record<string, never>;
  'market.part_of': { question: string };
  'market.sides': { a: string; b: string };
  'market.details': Record<string, never>;
  'market.side_group': Record<string, never>;
  'market.tabs': Record<string, never>;
  'market.tab_book': Record<string, never>;
  'market.tab_trades': Record<string, never>;
  'market.book_title': { side: string };
  'market.trades_title': { side: string };
  'book.aria': { side: string };
  'common.price': Record<string, never>;
  'common.shares': Record<string, never>;
  'common.total': Record<string, never>;
  'book.loading': Record<string, never>;
  'book.empty': { side: string };
  'book.asks': Record<string, never>;
  'book.bids': Record<string, never>;
  'common.mid': Record<string, never>;
  'book.spread': Record<string, never>;
  'book.buy_at': { px: string };
  'book.sell_at': { px: string };
  'book.bid_at': { px: string };
  'market.trades.heading': Record<string, never>;
  'common.time': Record<string, never>;
  'trades.none': Record<string, never>;
  'trades.buy_at': { px: string };
  'trades.sell_at': { px: string };
  'market.settled': Record<string, never>;
  'market.awaiting': Record<string, never>;
  'touch.badge': Record<string, never>;
  'touch.badge_title': Record<string, never>;
  'touch.title': Record<string, never>;
  'touch.early': Record<string, never>;
  'touch.mark': Record<string, never>;
  'touch.mark_unavailable': Record<string, never>;
  'touch.distance': Record<string, never>;
  'touch.how': Record<string, never>;
  'touch.twap': { seconds: number };
  'touch.twap_unknown': Record<string, never>;
  'touch.venue': { venue: string };
  'touch.venue_unknown': Record<string, never>;
  'ticket.title': Record<string, never>;
  'ticket.learn_link': Record<string, never>;
  'ticket.side_group': Record<string, never>;
  'ticket.action_group': Record<string, never>;
  'ticket.buy': Record<string, never>;
  'ticket.sell': Record<string, never>;
  'ticket.sell_disabled': { side: string };
  'ticket.submit': { action: string; side: string };
  'ticket.placing': Record<string, never>;
  'ticket.connect_to_trade': Record<string, never>;
  'ticket.checking_venue': Record<string, never>;
  'ticket.out_of_venue': { outcome: string; venue: string };
  'ticket.mainnet_off': Record<string, never>;
  'ticket.ghost': Record<string, never>;
  'ticket.balances_stale': Record<string, never>;
  'ticket.down_title': { network: string };
  'ticket.approve_fee_first': Record<string, never>;
  'ticket.est_avg_price': Record<string, never>;
  'ticket.loading_book': Record<string, never>;
  'ticket.worst_price': Record<string, never>;
  'ticket.limit_price_row': Record<string, never>;
  'ticket.worst_cost': Record<string, never>;
  'ticket.worst_proceeds': Record<string, never>;
  'ticket.limit_price': Record<string, never>;
  'ticket.limit_price_aria': Record<string, never>;
  'ticket.limit_price_placeholder': { example: string };
  'ticket.per_share': { px: string };
  'ticket.max': { n: string };
  'ticket.tif': Record<string, never>;
  'ticket.tif.market': Record<string, never>;
  'ticket.tif.gtc_help': Record<string, never>;
  'ticket.tif.ioc_help': Record<string, never>;
  'ticket.tif.alo_help': Record<string, never>;
  'ticket.tif.market_help': Record<string, never>;
  'ticket.tif.market_ioc': Record<string, never>;
  'ticket.reduce_only': Record<string, never>;
  'ticket.est_cost': Record<string, never>;
  'ticket.max_payout': Record<string, never>;
  'ticket.potential_profit': Record<string, never>;
  'ticket.est_proceeds': Record<string, never>;
  'ticket.outfox_fee': Record<string, never>;
  'ticket.available_usdc': Record<string, never>;
  'ticket.held': { first: string; second: string };
  'ticket.results': Record<string, never>;
  'ticket.no_shares_stays_buy': { side: string };
  'ticket.agent_gone': Record<string, never>;
  'ticket.signature_canceled': Record<string, never>;
  'ticket.order_failed': Record<string, never>;
  'ticket.summary_line': { action: string; sz: string; side: string; at: string; title: string };
  'ticket.summary_at_market': { px: string };
  'ticket.summary_at_limit': { px: string; tif: string };
  'ticket.summary.network': Record<string, never>;
  'common.market': Record<string, never>;
  'ticket.summary.action': Record<string, never>;
  'ticket.summary.max_cost': Record<string, never>;
  'ticket.summary.min_proceeds': Record<string, never>;
  'ticket.summary.amount_usdc': { amount: string };
  'ticket.mainnet_title': Record<string, never>;
  'ticket.mainnet_warning': Record<string, never>;
  'ticket.place_order': Record<string, never>;
  'ticket.continue_wallet': Record<string, never>;
  'ticket.agent_title': Record<string, never>;
  'ticket.agent_body': Record<string, never>;
  'ticket.error.enter_price': { example: string };
  'ticket.warn.no_sellers': { side: string };
  'ticket.warn.no_buyers': { side: string };
  'ticket.warn.partial': { fillable: string; sz: string };
  'ticket.warn.market_min': { value: string; min: string };
  'common.mainnet_off': Record<string, never>;
  'ticket.err.agent_sign': { error: string };
  'wallet.error_generic': { error: string };
  'ticket.status.resting': { oid: string };
  'ticket.status.filled_avg': { sz: string; px: string };
  'ticket.status.oid_suffix': { oid: string };
  'ticket.status.partial': { filled: string; orig: string; px: string };
  'ticket.status.resting_short': Record<string, never>;
  'ticket.status.filled': { sz: string; px: string };
  'ticket.status.part_filled': { filled: string; orig: string };
  'ticket.wallet_confirm.title': Record<string, never>;
  'ticket.wallet_confirm.order': { prompt: string };
  'ticket.wallet_confirm.cancel': { prompt: string };
  'ticket.open_orders.label': Record<string, never>;
  'ticket.open_orders.title': Record<string, never>;
  'ticket.open_orders.cancel_all': { n: number };
  'common.loading': Record<string, never>;
  'ticket.open_orders.none': Record<string, never>;
  'cancel.canceling': Record<string, never>;
  'cancel.button': Record<string, never>;
  'cancel.button_aria': { oid: string };
  'cancel.signature_canceled': Record<string, never>;
  'cancel.failed': Record<string, never>;
  'cancel.no_status': Record<string, never>;
  'cancel.never_placed': Record<string, never>;
  'orders.toast.describe': { action: string; sz: string; label: string; px: string };
  'rules.side_invalid': Record<string, never>;
  'rules.price_invalid': Record<string, never>;
  'rules.price_positive': Record<string, never>;
  'rules.price_below_one': Record<string, never>;
  'rules.price_decimals_outcome': { n: string; tick: string };
  'rules.price_sig_figs': { n: string };
  'rules.price_decimals': { n: string };
  'rules.size_invalid': Record<string, never>;
  'rules.size_min_share': Record<string, never>;
  'rules.size_positive': Record<string, never>;
  'rules.size_whole': Record<string, never>;
  'rules.size_decimals': { n: string };
  'rules.min_value': { value: string; min: string };
  'rules.buy_reduce_only': Record<string, never>;
  'rules.no_shares': { side: string };
  'rules.sell_at_most': { held: string; side: string; sz: string };
  'rules.not_enough_usdc': { cost: string; avail: string };
  'portfolio.watching': { address: string };
  'portfolio.empty': Record<string, never>;
  'portfolio.ghost_input': Record<string, never>;
  'portfolio.ghost_placeholder': Record<string, never>;
  'portfolio.watch': Record<string, never>;
  'portfolio.not_valid': Record<string, never>;
  'portfolio.sections': Record<string, never>;
  'portfolio.tab.balances': Record<string, never>;
  'portfolio.tab.positions': Record<string, never>;
  'portfolio.tab.orders': Record<string, never>;
  'portfolio.tab.history': Record<string, never>;
  'portfolio.tab.trades': Record<string, never>;
  'portfolio.tab.settled': Record<string, never>;
  'portfolio.pending': { panel: string };
  'balances.load_error': { error: string };
  'balances.usdc_total': Record<string, never>;
  'balances.in_open_orders': Record<string, never>;
  'balances.available': Record<string, never>;
  'balances.outcome_value': Record<string, never>;
  'balances.outcome_tokens': Record<string, never>;
  'balances.upnl': { value: string };
  'balances.no_tokens': Record<string, never>;
  'balances.no_tokens_venue': { venue: string };
  'balances.other': Record<string, never>;
  'balances.other_count': { n: number };
  'balances.col.side': Record<string, never>;
  'balances.col.avg_entry': Record<string, never>;
  'balances.col.value': Record<string, never>;
  'balances.col.upnl': Record<string, never>;
  'balances.in_orders': { n: string };
  'balances.col.token': Record<string, never>;
  'balances.col.in_orders': Record<string, never>;
  'balances.col.cost_basis': Record<string, never>;
  'positions.outcome': Record<string, never>;
  'positions.no_outcome': Record<string, never>;
  'positions.no_outcome_venue': { venue: string };
  'positions.sort.label': Record<string, never>;
  'positions.sort.current': { order: string };
  'positions.sort.value_desc': Record<string, never>;
  'positions.sort.outcome_asc': Record<string, never>;
  'positions.sort.outcome_desc': Record<string, never>;
  'positions.sort.shares_asc': Record<string, never>;
  'positions.sort.shares_desc': Record<string, never>;
  'positions.close.button': Record<string, never>;
  'positions.close.aria': { side: string; title: string };
  'positions.close.ready': { n: string; side: string };
  'positions.close.reserved': { reserved: string; total: string; side: string; free: string };
  'positions.close.all_reserved': { total: string; side: string };
  'positions.close.nothing': { side: string };
  'positions.perp': Record<string, never>;
  'positions.main_dex': Record<string, never>;
  'positions.perp_error': { error: string };
  'positions.account_value': Record<string, never>;
  'positions.margin_used': Record<string, never>;
  'positions.maintenance': Record<string, never>;
  'positions.withdrawable': Record<string, never>;
  'positions.upnl': Record<string, never>;
  'positions.no_perp': Record<string, never>;
  'positions.col.coin': Record<string, never>;
  'positions.col.size': Record<string, never>;
  'positions.col.value': Record<string, never>;
  'positions.col.entry': Record<string, never>;
  'positions.col.mark': Record<string, never>;
  'positions.col.upnl_roe': Record<string, never>;
  'positions.col.leverage': Record<string, never>;
  'positions.col.liq': Record<string, never>;
  'orders.outcomes_only': Record<string, never>;
  'orders.no_outcome_activity': Record<string, never>;
  'orders.hidden_other': { n: number };
  'orders.load_more': Record<string, never>;
  'orders.load_older_fills': Record<string, never>;
  'orders.col.side': Record<string, never>;
  'orders.col.size': Record<string, never>;
  'orders.col.filled': Record<string, never>;
  'orders.col.type': Record<string, never>;
  'orders.col.reduce_only': Record<string, never>;
  'orders.col.status': Record<string, never>;
  'orders.col.fee': Record<string, never>;
  'orders.col.closed_pnl': Record<string, never>;
  'orders.col.position_after': Record<string, never>;
  'orders.type.limit': Record<string, never>;
  'orders.type.stop_market': Record<string, never>;
  'orders.type.stop_limit': Record<string, never>;
  'orders.type.tp_market': Record<string, never>;
  'orders.type.tp_limit': Record<string, never>;
  'orders.post_only': Record<string, never>;
  'orders.cancel_unavailable': Record<string, never>;
  'orders.other_venue': Record<string, never>;
  'orders.only_outcome': Record<string, never>;
  'orders.open.error': { error: string };
  'orders.open.loading': Record<string, never>;
  'orders.open.none': Record<string, never>;
  'orders.history.error': { error: string };
  'orders.history.loading': Record<string, never>;
  'orders.history.none': Record<string, never>;
  'orders.fills.title': Record<string, never>;
  'orders.fills.error': { error: string };
  'orders.fills.loading': Record<string, never>;
  'orders.fills.none': Record<string, never>;
  'orders.fills.none_yet': Record<string, never>;
  'orders.fills.capped_note': { limit: number };
  'orders.status.open': Record<string, never>;
  'orders.status.filled': Record<string, never>;
  'orders.status.canceled': Record<string, never>;
  'orders.status.triggered': Record<string, never>;
  'orders.status.rejected': Record<string, never>;
  'orders.reason.by_user': Record<string, never>;
  'orders.reason.margin': Record<string, never>;
  'orders.reason.reduce_only': Record<string, never>;
  'orders.reason.self_trade': Record<string, never>;
  'orders.reason.sibling': Record<string, never>;
  'orders.reason.scheduled': Record<string, never>;
  'orders.reason.liquidated': Record<string, never>;
  'orders.reason.vault_closed': Record<string, never>;
  'orders.reason.oi_cap': Record<string, never>;
  'orders.reason.delisted': Record<string, never>;
  'orders.reason.balance': Record<string, never>;
  'orders.reason.post_only': Record<string, never>;
  'orders.reason.ioc': Record<string, never>;
  'orders.reason.tick': Record<string, never>;
  'orders.reason.min_value': Record<string, never>;
  'orders.reason.oracle': Record<string, never>;
  'orders.toast.filled': Record<string, never>;
  'orders.toast.canceled': Record<string, never>;
  'orders.toast.rejected': Record<string, never>;
  'orders.toast.partial': Record<string, never>;
  'orders.toast.away': Record<string, never>;
  'orders.toast.away_many': { fills: string };
  'orders.toast.filled_avg': { label: string; sz: string; px: string };
  'orders.toast.part_of': { filled: string; orig: string };
  'orders.toast.fill': { label: string; sz: string; px: string };
  'orders.toast.of': { filled: string; orig: string };
  'orders.toast.side_label': { action: string; label: string };
  'orders.toast.describe_no_sz': { action: string; label: string; px: string };
  'settlement.result.won': Record<string, never>;
  'settlement.result.lost': Record<string, never>;
  'settlement.result.partial': Record<string, never>;
  'settlement.corrected': Record<string, never>;
  'settlement.col.settled': Record<string, never>;
  'settlement.col.side': Record<string, never>;
  'settlement.col.result': Record<string, never>;
  'settlement.col.payout': Record<string, never>;
  'settlement.col.total': Record<string, never>;
  'settlement.after_fee': { fee: string };
  'settlement.title': Record<string, never>;
  'settlement.checking': Record<string, never>;
  'settlement.week': Record<string, never>;
  'settlement.error': { error: string };
  'settlement.loading': Record<string, never>;
  'settlement.empty': Record<string, never>;
  'settlement.per_share': { amount: string };
  'settlement.badge': Record<string, never>;
  'settlement.mine': { shares: string; side: string; result: string; net: string; perShare: string; time: string };
  'settlement.col.profit': Record<string, never>;
  'settlement.profit_note': Record<string, never>;
  'settlement.summary.markets': { count: number };
  'settlement.summary.won': { count: number };
  'settlement.summary.lost': { count: number };
  'settlement.summary.partial': { count: number };
  'settlement.summary.profit': { amount: string };
  'settlement.summary.excluded': { count: number };
  'settlement.truncated': Record<string, never>;
  'settlement.truncated_info': { limit: number };
  'agent.indicator': { expiry: string };
  'agent.indicator_title': { address: string };
  'agent.unavailable_ghost': Record<string, never>;
  'agent.disable': Record<string, never>;
  'agent.enable': Record<string, never>;
  'agent.approve_in_wallet': Record<string, never>;
  'agent.ticket_hint': Record<string, never>;
  'agent.modal.approve': Record<string, never>;
  'agent.modal.what': { msg: string; network: string };
  'agent.modal.safety': Record<string, never>;
  'agent.not_listed': Record<string, never>;
  'agent.revoked': Record<string, never>;
  'agent.expired': Record<string, never>;
  'trade.agent.canceled_in_wallet': Record<string, never>;
  'common.approval_refused': { error: string };
  'agent.enable_failed': { error: string };
  'agent.turned_off': { reason: string };
  'builder.unknown': Record<string, never>;
  'builder.title': { pct: string };
  'builder.explain': { pct: string; address: string };
  'builder.once': { pct: string };
  'builder.confirm_in_wallet': Record<string, never>;
  'builder.approve': { pct: string };
  'builder.not_reported': Record<string, never>;
  'builder.canceled': Record<string, never>;
  'privacy.title': Record<string, never>;
  'learn.title': Record<string, never>;
  'learn.intro': Record<string, never>;
  'learn.on_this_page': Record<string, never>;
  'learn.nav.basics': Record<string, never>;
  'learn.nav.calculator': Record<string, never>;
  'learn.nav.trading': Record<string, never>;
  'learn.nav.settlement': Record<string, never>;
  'learn.nav.touch': Record<string, never>;
  'learn.nav.fees': Record<string, never>;
  'learn.section.settlement': Record<string, never>;
  'learn.basics.p1': { yes: string; no: string; one: string; zero: string };
  'learn.basics.p2': Record<string, never>;
  'learn.calc.intro': Record<string, never>;
  'learn.settlement.intro': Record<string, never>;
  'learn.fees.p1': { close: string; noFee: string };
  'learn.fees.p1_close': Record<string, never>;
  'learn.fees.p1_no_fee': Record<string, never>;
  'learn.fees.p2': { docs: string };
  'learn.fees.docs': Record<string, never>;
  'learn.fees.p3': { builderFee: string; buysSells: string };
  'learn.fees.p3_builder_fee': Record<string, never>;
  'learn.fees.p3_buys_sells': Record<string, never>;
  'learn.fees.builder_on': { pct: string };
  'learn.fees.builder_off': Record<string, never>;
  'learn.footer.sources': Record<string, never>;
  'learn.footer.browse': Record<string, never>;
  'learn.slider.label': Record<string, never>;
  'learn.slider.valuetext': { cents: number; pct: string };
  'learn.slider.bar_yes': { px: string };
  'learn.slider.bar_no': { px: string };
  'learn.slider.no_price': Record<string, never>;
  'learn.slider.yes_chance': { pct: string };
  'learn.slider.no_chance': { pct: string };
  'learn.slider.sum': { yes: string; no: string };
  'learn.calc.side_group': Record<string, never>;
  'order.action_buy': { side: string };
  'learn.calc.price': Record<string, never>;
  'learn.calc.cost': Record<string, never>;
  'learn.calc.max_payout': { side: string };
  'learn.calc.profit': Record<string, never>;
  'learn.calc.loss': Record<string, never>;
  'learn.calc.summary': { shares: string; side: string; px: string; pct: string };
  'learn.trading.limit.title': Record<string, never>;
  'learn.trading.limit.p1': Record<string, never>;
  'learn.trading.limit.p2': Record<string, never>;
  'learn.trading.open_close.title': Record<string, never>;
  'learn.trading.open_close.p1': { buying: string; selling: string };
  'learn.trading.buying': Record<string, never>;
  'learn.trading.selling': Record<string, never>;
  'learn.trading.open_close.p2': Record<string, never>;
  'learn.trading.leverage.title': Record<string, never>;
  'learn.trading.leverage.p1': Record<string, never>;
  'learn.trading.min.title': Record<string, never>;
  'learn.trading.min.p1': { min: string };
  'learn.trading.min.p2': { lo: string; hi: string; tick: string };
  'learn.trading.tif.title': Record<string, never>;
  'learn.trading.market': { buyPx: string; sellPx: string };
  'learn.fees.enter_valid': Record<string, never>;
  'learn.fees.scale_group': Record<string, never>;
  'learn.fees.scale_none': Record<string, never>;
  'learn.fees.scale_one': Record<string, never>;
  'learn.fees.scale_example': Record<string, never>;
  'learn.fees.example_title': { title: string };
  'learn.fees.sell_type': Record<string, never>;
  'learn.fees.taker': Record<string, never>;
  'learn.fees.maker': Record<string, never>;
  'learn.fees.sell_price': Record<string, never>;
  'learn.fees.caption': { shares: string; side: string; px: string; mult: string };
  'learn.fees.buy_label': { shares: string; side: string };
  'learn.fees.buy_note': { value: string };
  'learn.fees.sell_label': { px: string };
  'learn.fees.sell_note_taker': { pct: string; value: string };
  'learn.fees.sell_note_maker': { pct: string; value: string };
  'learn.fees.sell_enter': Record<string, never>;
  'learn.fees.settle_label': { side: string };
  'learn.fees.settle_note': { value: string };
  'learn.fees.builder_label': Record<string, never>;
  'learn.fees.builder_note': { pct: string; buy: string; sell: string };
  'learn.fees.builder_none': Record<string, never>;
  'learn.fees.rates': { taker: string; maker: string };
  'learn.example.loading': { network: string };
  'learn.example.error': Record<string, never>;
  'learn.example.none': { network: string };
  'learn.example.eyebrow': { network: string };
  'learn.example.pick': Record<string, never>;
  'learn.example.by_protocol': Record<string, never>;
  'learn.example.by_venue': { venue: string };
  'learn.example.mult': { mult: string; scale: string; first: string; second: string };
  'learn.example.scale': { scale: string };
  'learn.example.no_scale': Record<string, never>;
  'learn.example.raw': Record<string, never>;
  'learn.example.open': Record<string, never>;
  'learn.step.trade.label': Record<string, never>;
  'learn.step.trade.when': Record<string, never>;
  'learn.step.trade.p1': Record<string, never>;
  'learn.step.resolve.label': Record<string, never>;
  'learn.step.resolve.when_at': { label: string; time: string };
  'learn.step.resolve.when_rules': Record<string, never>;
  'learn.step.resolve.p1': Record<string, never>;
  'learn.step.resolve.p2': Record<string, never>;
  'learn.step.settle.label': Record<string, never>;
  'learn.step.settle.when_auto': Record<string, never>;
  'learn.step.settle.when_soon': Record<string, never>;
  'learn.step.settle.p1': Record<string, never>;
  'learn.step.settle.timing': Record<string, never>;
  'learn.step.settle.p2': { canceled: string };
  'learn.step.settle.canceled': Record<string, never>;
  'learn.step.payout.label': Record<string, never>;
  'learn.step.payout.when': Record<string, never>;
  'learn.step.payout.p1': Record<string, never>;
  'learn.step.payout.p2': Record<string, never>;
  'learn.timeline.aria': Record<string, never>;
  'learn.timeline.step': { n: number };
  'learn.timeline.position': { shares: string; side: string };
  'learn.timeline.result_group': Record<string, never>;
  'learn.timeline.yes_wins': Record<string, never>;
  'learn.timeline.no_wins': Record<string, never>;
  'learn.timeline.fraction': Record<string, never>;
  'learn.timeline.value': Record<string, never>;
  'learn.timeline.fee': Record<string, never>;
  'learn.timeline.receive': Record<string, never>;
  'learn.timeline.pnl': Record<string, never>;
  'learn.timeline.enter_valid': Record<string, never>;
  'learn.calc.enter_price': Record<string, never>;
  'learn.touch.p1': { yesTouch: string; no: string; deadline: string };
  'learn.touch.p1_yes': Record<string, never>;
  'learn.touch.p2': Record<string, never>;
  'learn.touch_ex.path_group': Record<string, never>;
  'learn.touch_ex.path_early': Record<string, never>;
  'learn.touch_ex.path_never': Record<string, never>;
  'learn.touch_ex.target_value': { price: string };
  'learn.touch_ex.chart': { path: string; price: string };
  'learn.touch_ex.listed': Record<string, never>;
  'learn.touch_ex.legend_price': Record<string, never>;
  'learn.touch_ex.legend_avg': { n: number };
  'learn.touch_ex.legend_target': Record<string, never>;
  'learn.touch_ex.touched_head': { n: number };
  'learn.touch_ex.touched_early': { head: string; price: string; yes: string; n: number };
  'learn.touch_ex.touched_deadline': { head: string; price: string; yes: string };
  'learn.touch_ex.never_head': Record<string, never>;
  'learn.touch_ex.never': { head: string; price: string; no: string };
  'privacy.updated': { date: string };
  'privacy.updated_date': Record<string, never>;
  'privacy.summary.lead': Record<string, never>;
  'privacy.summary.accounts': Record<string, never>;
  'privacy.summary.tracking': Record<string, never>;
  'privacy.summary.server': Record<string, never>;
  'privacy.summary.notifications': Record<string, never>;
  'privacy.summary.settings': Record<string, never>;
  'privacy.who.title': Record<string, never>;
  'privacy.who.p1': { publisher: string };
  'privacy.collect.title': Record<string, never>;
  'privacy.collect.p1': Record<string, never>;
  'privacy.notify.title': Record<string, never>;
  'privacy.notify.p1': Record<string, never>;
  'privacy.notify.token': Record<string, never>;
  'privacy.notify.device': Record<string, never>;
  'privacy.notify.address': Record<string, never>;
  'privacy.notify.prefs': Record<string, never>;
  'privacy.notify.p2': Record<string, never>;
  'privacy.notify.p3': Record<string, never>;
  'privacy.notify.p4': Record<string, never>;
  'privacy.notify.basis': Record<string, never>;
  'privacy.retention.title': Record<string, never>;
  'privacy.retention.p1': Record<string, never>;
  'privacy.retention.p2': Record<string, never>;
  'privacy.retention.p3': Record<string, never>;
  'privacy.processors.title': Record<string, never>;
  'privacy.processors.p1': Record<string, never>;
  'privacy.rights.title': Record<string, never>;
  'privacy.rights.p1': { contact: string };
  'privacy.hl.title': Record<string, never>;
  'privacy.hl.p1': Record<string, never>;
  'privacy.hl.p2': Record<string, never>;
  'privacy.wallets.title': Record<string, never>;
  'privacy.wallets.p1': Record<string, never>;
  'privacy.wallets.p2': Record<string, never>;
  'privacy.device.title': Record<string, never>;
  'privacy.device.p1': Record<string, never>;
  'privacy.device.network': Record<string, never>;
  'privacy.device.watch': Record<string, never>;
  'privacy.device.tour': Record<string, never>;
  'privacy.device.notify': Record<string, never>;
  'privacy.device.agent': Record<string, never>;
  'privacy.device.p2': Record<string, never>;
  'privacy.hosting.title': Record<string, never>;
  'privacy.hosting.p1': Record<string, never>;
  'privacy.permissions.title': Record<string, never>;
  'privacy.permissions.p1': Record<string, never>;
  'privacy.children.title': Record<string, never>;
  'privacy.children.p1': Record<string, never>;
  'privacy.changes.title': Record<string, never>;
  'privacy.changes.p1': { contact: string };
  'lang.menu': Record<string, never>;
  'lang.current': { name: string };
  'lang.system': Record<string, never>;
  'lang.list': Record<string, never>;
  'common.size': Record<string, never>;
  'common.value': Record<string, never>;
  'common.bullet_line': { line: string };
  'app.menu.a11y': { network: string };
  'app.menu.about': Record<string, never>;
  'app.language.note': Record<string, never>;
  'app.mainnet_confirm.title': Record<string, never>;
  'app.mainnet_confirm.body': Record<string, never>;
  'app.mainnet_confirm.use': Record<string, never>;
  'app.mainnet_confirm.stay': Record<string, never>;
  'about.tagline': Record<string, never>;
  'about.disclaimer': Record<string, never>;
  'about.version': { version: string; build: string };
  'about.mainnet_off': Record<string, never>;
  'about.privacy.line_1': Record<string, never>;
  'about.privacy.line_2': Record<string, never>;
  'about.privacy.line_3': Record<string, never>;
  'about.privacy.line_4': Record<string, never>;
  'about.privacy.notifications': Record<string, never>;
  'about.privacy.line_5': Record<string, never>;
  'ghost.header.open': Record<string, never>;
  'ghost.header.open_a11y': Record<string, never>;
  'catalog.sort.button': { sort: string };
  'market.header.raw_name': { name: string };
  'catalog.question.id': { id: string };
  'market.header.sides': Record<string, never>;
  'market.header.raw_description': { description: string };
  'market.trades.loading': Record<string, never>;
  'market.ticket.coming_soon': Record<string, never>;
  'time.utc_suffix': { time: string };
  'portfolio.account.yours': { address: string };
  'portfolio.empty.body': Record<string, never>;
  'portfolio.other_tokens': { count: number };
  'portfolio.positions.leverage': { leverage: string };
  'portfolio.order.filled': Record<string, never>;
  'portfolio.fills.from': { amount: string };
  'ticket.market.note_buy': { price: string };
  'ticket.market.note_sell': { price: string };
  'ticket.price_placeholder': Record<string, never>;
  'ticket.builder_fee': { pct: string };
  'ticket.builder.how': { pct: string };
  'ticket.builder.connect': Record<string, never>;
  'ticket.builder.confirm_in': { wallet: string };
  'wallet.your_wallet': Record<string, never>;
  'ticket.wallet.note': Record<string, never>;
  'ticket.wallet.manage': Record<string, never>;
  'wallet.waiting.approve_in': { wallet: string };
  'ticket.agent.turning_on': Record<string, never>;
  'ticket.summary.market_value': { title: string; id: string };
  'ticket.confirm.agent': Record<string, never>;
  'orders.cancel.ghost': Record<string, never>;
  'trade.toast.with_detail': { order: string; detail: string };
  'trade.toast.fee_approved': Record<string, never>;
  'trade.toast.fee_approved_body': Record<string, never>;
  'trade.toast.agent_expired': Record<string, never>;
  'trade.toast.agent_expired_body': Record<string, never>;
  'trade.toast.agent_gone': Record<string, never>;
  'trade.toast.agent_gone_body': Record<string, never>;
  'trade.agent.changed': Record<string, never>;
  'trade.agent.gone_notice': Record<string, never>;
  'trade.builder.no_wallet': Record<string, never>;
  'trade.builder.other_wallet': Record<string, never>;
  'trade.agent.canceled_in_app': Record<string, never>;
  'wallet.err.generic': Record<string, never>;
  'ticket.result.status': { status: string; oid: string };
  'wallet.footnote_unverified': Record<string, never>;
  'wallet.connected_note': Record<string, never>;
  'wallet.enable_explainer': Record<string, never>;
  'wallet.title.connected': Record<string, never>;
  'wallet.preparing': Record<string, never>;
  'wallet.intro': Record<string, never>;
  'wallet.retry': Record<string, never>;
  'wallet.installed': Record<string, never>;
  'wallet.get_app': Record<string, never>;
  'wallet.other_device': Record<string, never>;
  'wallet.copy_link': Record<string, never>;
  'wallet.qr.hide': Record<string, never>;
  'wallet.qr.show': Record<string, never>;
  'wallet.qr.scan': Record<string, never>;
  'wallet.qr.a11y': Record<string, never>;
  'wallet.browser_links': Record<string, never>;
  'wallet.waiting.body': { wallet: string };
  'wallet.open': { wallet: string };
  'wallet.other_wallet': Record<string, never>;
  'wallet.chain': { chain: string };
  'wallet.chain.unknown': Record<string, never>;
  'wallet.unavailable': Record<string, never>;
  'wallet.relay_error': Record<string, never>;
  'wallet.request.title': { wallet: string };
  'wallet.request.detail': { wallet: string };
  'wallet.open_failed': { wallet: string };
  'wallet.link_copied': Record<string, never>;
  'wallet.canceled_in_app': Record<string, never>;
  'wallet.connected_line': { address: string };
  'wallet.connected_line_named': { address: string; wallet: string };
  'learn.chip': { n: number; title: string };
  'learn.section.expanded': Record<string, never>;
  'learn.section.collapsed': Record<string, never>;
  'learn.slider.implied': { side: string };
  'learn.calc.buy_yes': Record<string, never>;
  'learn.calc.buy_no': Record<string, never>;
  'learn.example.a11y': { title: string };
  'learn.touch.marker_at': { step: number };
  'learn.touch.no_touch': Record<string, never>;
  'market.book.heading': Record<string, never>;
  'menu.wc_debug': Record<string, never>;
  'market.book.hint_buy': Record<string, never>;
  'market.book.hint_sell': Record<string, never>;
  'order.action_sell': { side: string };
  'order.state.open': Record<string, never>;
  'order.state.filled': Record<string, never>;
  'order.state.canceled': Record<string, never>;
  'order.state.rejected': Record<string, never>;
  'order.state.triggered': Record<string, never>;
  'builder.canceled_in_app': Record<string, never>;
  'builder.connect_wallet': Record<string, never>;
  'builder.wrong_wallet': { address: string };
  'about.privacy_5_ios': Record<string, never>;
  'account.a11y': Record<string, never>;
  'portfolio.no_account.note': Record<string, never>;
  'portfolio.col.value': Record<string, never>;
  'portfolio.perp_positions': Record<string, never>;
  'portfolio.col.size': Record<string, never>;
  'portfolio.col.liq': Record<string, never>;
  'portfolio.hidden_other': { count: number };
  'portfolio.col.filled': Record<string, never>;
  'wallet.picker.intro': Record<string, never>;
  'wallet.picker.approve_connection': { wallet: string };
  'wallet.picker.row.address': Record<string, never>;
  'wallet.picker.agent_soon': Record<string, never>;
  'wallet.picker.test_request': Record<string, never>;
  'wallet.picker.open_in': { wallet: string };
  'wallet.picker.browser_note': Record<string, never>;
  'wallet.picker.not_detected': Record<string, never>;
  'wallet.picker.a11y_installed': { wallet: string };
  'wallet.picker.a11y_not_detected': { wallet: string };
  'wallet.picker.qr_unavailable': Record<string, never>;
  'wallet.picker.request_timeout': Record<string, never>;
  'learn.a11y.option': { group: string };
  'learn.slider.tile_a11y': { price: string; pct: string; side: string };
  'wallet.err.connect_rejected': Record<string, never>;
  'wallet.err.connect_unsupported': Record<string, never>;
  'wallet.err.connect_timeout': Record<string, never>;
  'wallet.err.chain_mismatch': Record<string, never>;
  'wallet.err.timeout': Record<string, never>;
  'wallet.err.bad_signature': Record<string, never>;
  'wallet.err.l1_unsupported': Record<string, never>;
  'wallet.coming_soon': Record<string, never>;
  'trade.agent_not_registered': Record<string, never>;
  'settled.side_won': { side: string };
  'settled.split': { sideA: string; payoutA: string; sideB: string; payoutB: string };
  'settled.price': { price: string };
  'push.testnet_title': { title: string };
  'push.order.body': { side: string; market: string; count: number; price: string };
  'push.order.body_partial': { side: string; market: string; filled: number; total: number; price: string };
  'push.order.body_hidden': { side: string; market: string };
  'push.cancel.body': { side: string; market: string; reason: string };
  'push.cancel_settled.title': Record<string, never>;
  'push.cancel_settled.body': { market: string; count: number };
  'push.settle.title': Record<string, never>;
  'push.settle.body': { market: string; result: string; amount: string };
  'push.settle.body_hidden': { market: string; result: string };
  'push.settle.body_split_hidden': { market: string };
  'push.alert.title': Record<string, never>;
  'push.alert.body_above': { side: string; market: string; price: string; target: string };
  'push.alert.body_below': { side: string; market: string; price: string; target: string };
  'push.alert.body_hidden': { side: string; market: string };
  'push.delayed.title': Record<string, never>;
  'push.delayed.body': { market: string; count: number };
  'notif.title': Record<string, never>;
  'notif.intro': Record<string, never>;
  'notif.master.label': Record<string, never>;
  'notif.master.detail': Record<string, never>;
  'notif.master.working': Record<string, never>;
  'notif.permission.denied': Record<string, never>;
  'notif.permission.open_settings': Record<string, never>;
  'notif.types.heading': Record<string, never>;
  'notif.type.fills': Record<string, never>;
  'notif.type.partials': Record<string, never>;
  'notif.type.cancels': Record<string, never>;
  'notif.type.settlement': Record<string, never>;
  'notif.type.alerts': Record<string, never>;
  'notif.show_amounts.label': Record<string, never>;
  'notif.show_amounts.detail': Record<string, never>;
  'notif.addresses.heading': Record<string, never>;
  'notif.addresses.empty': Record<string, never>;
  'notif.addresses.add': { address: string; network: string };
  'notif.addresses.sign_hint': Record<string, never>;
  'notif.addresses.connect_first': Record<string, never>;
  'notif.addresses.ghost': Record<string, never>;
  'notif.addresses.row': { address: string; network: string };
  'notif.addresses.remove': Record<string, never>;
  'notif.addresses.remove_a11y': { address: string };
  'notif.alerts.empty': Record<string, never>;
  'notif.alerts.row_above': { side: string; price: string };
  'notif.alerts.row_below': { side: string; price: string };
  'notif.alerts.market': { id: string; network: string };
  'notif.alerts.fired': Record<string, never>;
  'notif.alerts.delete': Record<string, never>;
  'notif.alert_new.button': Record<string, never>;
  'notif.alert_new.title': Record<string, never>;
  'notif.alert_new.side': Record<string, never>;
  'notif.alert_new.above': Record<string, never>;
  'notif.alert_new.below': Record<string, never>;
  'notif.alert_new.price': Record<string, never>;
  'notif.alert_new.current': { price: string };
  'notif.alert_new.invalid': Record<string, never>;
  'notif.alert_new.create': Record<string, never>;
  'notif.alert_new.created': Record<string, never>;
  'notif.alert_new.needs_on': Record<string, never>;
  'notif.error.mainnet': Record<string, never>;
  'notif.error.server': Record<string, never>;
  'notif.error.rate_limited': Record<string, never>;
  'notif.error.rejected': Record<string, never>;
  'notif.error.signature': Record<string, never>;
  'notif.error.message': Record<string, never>;
  'notif.error.limit_addresses': Record<string, never>;
  'notif.error.limit_alerts': Record<string, never>;
  'notif.error.capacity': Record<string, never>;
  'notif.error.unknown_outcome': Record<string, never>;
  'notif.error.reset': Record<string, never>;
  'geo.loading': Record<string, never>;
  'geo.blocked.title': Record<string, never>;
  'geo.blocked.body': { place: string };
  'geo.blocked.help': Record<string, never>;
  'geo.browse_only.unknown': Record<string, never>;
  'geo.browse_only.unknown_app': Record<string, never>;
  'geo.browse_only.known': { place: string };
  'geo.place.region': { country: string; region: string };
  'geo.place.unknown': Record<string, never>;
  'geo.agent_unavailable': { reason: string };
  'terms.title': Record<string, never>;
  'terms.footer_link': Record<string, never>;
  'terms.version_line': { version: string; date: string };
  'terms.draft_badge': Record<string, never>;
  'terms.english_only': Record<string, never>;
  'terms.accept': Record<string, never>;
}

export type MessageKey = keyof MessageArgs;
